import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const FieldSelection = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={() => {
        return (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 1261161553">
              <path
                id="Vector"
                d="M10 3.25C10 3.84674 10.2371 4.41903 10.659 4.84099C11.081 5.26295 11.6533 5.5 12.25 5.5C12.8467 5.5 13.419 5.26295 13.841 4.84099C14.2629 4.41903 14.5 3.84674 14.5 3.25C14.5 2.65326 14.2629 2.08097 13.841 1.65901C13.419 1.23705 12.8467 1 12.25 1C11.6533 1 11.081 1.23705 10.659 1.65901C10.2371 2.08097 10 2.65326 10 3.25Z"
                stroke="white"
                strokeWidth="1.61719"
                strokeLinecap="square"
              />
              <g id="Vector_2">
                <path d="M1 3.25H10H1Z" fill="#3A5572" />
                <path d="M1 3.25H10" stroke="white" strokeWidth="1.61719" strokeLinecap="square" />
              </g>
              <g id="Vector_3">
                <path d="M14.5 3.25H19H14.5Z" fill="#3A5572" />
                <path d="M14.5 3.25H19" stroke="white" strokeWidth="1.61719" strokeLinecap="square" />
              </g>
              <path
                id="Vector_4"
                d="M3.24976 10C3.24976 10.5967 3.48681 11.169 3.90877 11.591C4.33072 12.0129 4.90302 12.25 5.49976 12.25C6.09649 12.25 6.66879 12.0129 7.09075 11.591C7.5127 11.169 7.74976 10.5967 7.74976 10C7.74976 9.40326 7.5127 8.83097 7.09075 8.40901C6.66879 7.98705 6.09649 7.75 5.49976 7.75C4.90302 7.75 4.33072 7.98705 3.90877 8.40901C3.48681 8.83097 3.24976 9.40326 3.24976 10Z"
                stroke="white"
                strokeWidth="1.61719"
                strokeLinecap="square"
              />
              <g id="Vector_5">
                <path d="M1 9.99951H3.25H1Z" fill="#3A5572" />
                <path d="M1 9.99951H3.25" stroke="white" strokeWidth="1.61719" strokeLinecap="square" />
              </g>
              <g id="Vector_6">
                <path d="M7.75 9.99951H19H7.75Z" fill="#3A5572" />
                <path d="M7.75 9.99951H19" stroke="white" strokeWidth="1.61719" strokeLinecap="square" />
              </g>
              <path
                id="Vector_7"
                d="M13.375 16.75C13.375 17.3467 13.6121 17.919 14.034 18.341C14.456 18.7629 15.0283 19 15.625 19C16.2217 19 16.794 18.7629 17.216 18.341C17.6379 17.919 17.875 17.3467 17.875 16.75C17.875 16.1533 17.6379 15.581 17.216 15.159C16.794 14.7371 16.2217 14.5 15.625 14.5C15.0283 14.5 14.456 14.7371 14.034 15.159C13.6121 15.581 13.375 16.1533 13.375 16.75Z"
                stroke="white"
                strokeWidth="1.61719"
                strokeLinecap="square"
              />
              <g id="Vector_8">
                <path d="M1 16.75H13.375H1Z" fill="#3A5572" />
                <path d="M1 16.75H13.375" stroke="white" strokeWidth="1.61719" strokeLinecap="square" />
              </g>
              <g id="Vector_9">
                <path d="M17.875 16.75H19H17.875Z" fill="#3A5572" />
                <path d="M17.875 16.75H19" stroke="white" strokeWidth="1.61719" strokeLinecap="square" />
              </g>
            </g>
          </svg>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

FieldSelection.displayName = "Fields Selection";

const FieldSelectionLoader = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={() => {
        return (
          <svg width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="white">
            <g fill="none" fillRule="evenodd">
              <g transform="translate(1 1)" strokeWidth="3">
                <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </path>
              </g>
            </g>
          </svg>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

FieldSelectionLoader.displayName = "Fields Selection Loader";

export { FieldSelection, FieldSelectionLoader };
